/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Analysis-page traffic exploration chart and tables.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';

import {AppSharedModule} from '../app-shared.module';
import {ExplorationComponent} from './exploration.component';
import {ExplorationTableComponent} from './exploration-table.component';

const EXPLORATION = [
  ExplorationComponent,
  ExplorationTableComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    BsDatepickerModule
  ],
  declarations: EXPLORATION,
  exports: EXPLORATION
})
export class ExplorationModule {
}
